import { InfoMesssages } from 'types/infoMessages';
import VisaIcon from 'assets/icons/VisaIcon.svg';
import AmexIcon from 'assets/icons/AmexIcon.svg';
import DiscoverIcon from 'assets/icons/DiscoverIcon.svg';
import MasterCardIcon from 'assets/icons/MasterCardIcon.svg';
import OtherPaymentIcon from 'assets/icons/OtherPaymentIcon.svg';
import DirectTransferIcon from 'assets/icons/DirectTransferIcon.svg';
import CashIcon from 'assets/icons/CashIcon.svg';
import CheckIcon from 'assets/icons/CheckIcon.svg';
import ZelleIcon from 'assets/icons/ZelleIcon.svg';
import CheckDepositIcon from 'assets/icons/CheckDepositIcon.svg';
import { ReceiptByIdResponse } from './receipt.model';
import { If } from 'components';
import { getDisputeStatusColor } from 'containers/disputes/utils';
import { getInvoiceStatus } from 'containers/invoices/utils';
import { getInvoiceStatusColor } from 'containers/invoices/utils';
import {
  ManualPaymentMethodValues,
  ManualPaymentMethods,
  PaymentMethodsForInvoiceFilter
} from 'containers/home/components/constants';
import { PaymentMethods } from 'constants/common';
import { ReceiptStatus } from './receipts.model';

export const isEmpty = (value: string) => {
  return !value || value.length === 0;
};

export const getReceiptStatus = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
      return 'Canceled';
    case ReceiptStatus.FAILED:
      return 'Failed';
    case ReceiptStatus.PENDING:
      return 'Pending';
    case ReceiptStatus.SUCCESS:
      return 'Success';
    case ReceiptStatus.REFUNDED:
      return 'Refunded';
    case ReceiptStatus.BLOCKED:
      return 'Blocked';
    case ReceiptStatus.TIMED_OUT:
      return 'Timed Out';
    case ReceiptStatus.INITIATED:
      return 'Initiated';
    case ReceiptStatus.REFUND_INITIATED:
      return 'Refund Initiated';
    case ReceiptStatus.REFUND_RETURNED:
      return 'Refund returned';
    case ReceiptStatus.VOID:
      return 'Void';
    case ReceiptStatus.DISPUTED:
      return 'Disputed';
    default:
      return status;
  }
};

export const getPayoutStatus = (status: string) => {
  switch (status) {
    case 'ON_HOLD':
      return 'On hold';
    case 'FAILED':
      return 'Failed';
    case 'PENDING':
    case 'IN_TRANSIT':
      return 'In transit';
    case 'SUCCESS':
      return 'Success';
    default:
      return '';
  }
};

export const getReceiptStatusColor = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
    case ReceiptStatus.FAILED:
    case ReceiptStatus.VOID:
      return '#FF7A7A';
    case ReceiptStatus.PENDING:
      return '#F2994A';
    case ReceiptStatus.SUCCESS:
      return '#419364';
    case ReceiptStatus.REFUND_INITIATED:
    case ReceiptStatus.REFUNDED:
    case ReceiptStatus.REFUND_RETURNED:
      return '#3876BB';
    case ReceiptStatus.BLOCKED:
      return '#FF0000';
    case ReceiptStatus.TIMED_OUT:
      return '#800000';
    case ReceiptStatus.INITIATED:
      return '#4F4F4F';
    default:
      return '#4F4F4F';
  }
};

export const getPayoutStatusColor = (status: string) => {
  switch (status) {
    case 'ON_HOLD':
      return '#F2994A';
    case 'FAILED':
      return '#FF7A7A';
    case 'PENDING':
      return '#F2B85C';
    case 'SUCCESS':
      return '#419364';
  }
};

export const getReceiptStatusBackgroundColor = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
      return '#F2B85C';
    case ReceiptStatus.FAILED:
    case ReceiptStatus.BLOCKED:
    case ReceiptStatus.VOID:
      return '#F7C0C0';
    case ReceiptStatus.PENDING:
      return '#F7E2C0';
    case ReceiptStatus.SUCCESS:
      return '#CBF4C9';
    case ReceiptStatus.REFUNDED:
    case ReceiptStatus.INITIATED:
    case ReceiptStatus.REFUND_INITIATED:
    case ReceiptStatus.REFUND_RETURNED:
      return '#A4D7FA';
    case ReceiptStatus.TIMED_OUT:
      return '#ECF1F7';
    default:
      return '#ECF1F7';
  }
};
export const getReceiptDetailStatusColor = (status: string) => {
  switch (status) {
    case ReceiptStatus.CANCELLED:
    case ReceiptStatus.FAILED:
    case ReceiptStatus.PENDING:
    case ReceiptStatus.SUCCESS:
    case ReceiptStatus.REFUND_INITIATED:
    case ReceiptStatus.REFUNDED:
    case ReceiptStatus.INITIATED:
    case ReceiptStatus.REFUND_RETURNED:
    case ReceiptStatus.VOID:
      return '#3E556D';
    case ReceiptStatus.BLOCKED:
      return '#FF0000';
    case ReceiptStatus.TIMED_OUT:
      return '#800000';
    default:
      return '#3E556D';
  }
};

export const getRefundDisabledReason = (
  isManualPayment,
  refundPermissions,
  isCreatedBySelf,
  isAlreadyRefunded,
  paymentMethod
) => {
  if (isManualPayment) return InfoMesssages.refundManualPaymentDisabledMessage;
  if (isAlreadyRefunded) return InfoMesssages.refundAlreadyProcessedDisabledMessage;
  if (!(refundPermissions.createRefundsByTeam || (isCreatedBySelf && refundPermissions.createRefundsBySelf))) {
    return InfoMesssages.refundNoPermissionMessage;
  }
  if (paymentMethod === PaymentMethods.MOBILE_CHECK_DEPOSIT || paymentMethod === 'check-deposit')
    return InfoMesssages.refundCheckDepositDisabledMessage;
  return 'Refund is not allowed for this payment method';
};

export const shouldEnableRefund = (
  isManualPayment,
  refundPermissions,
  isCreatedBySelf,
  isAlreadyRefunded,
  paymentMethod
) => {
  return (
    !isManualPayment &&
    !isAlreadyRefunded &&
    (refundPermissions.createRefundsByTeam || (isCreatedBySelf && refundPermissions.createRefundsBySelf)) &&
    paymentMethod !== PaymentMethods.MOBILE_CHECK_DEPOSIT &&
    paymentMethod !== 'check-deposit'
  );
};

export function getCardType(cardType) {
  switch (cardType) {
    case 'amex':
      return 'AMEX';
    case 'visa':
      return 'Visa';
    case 'discover':
      return 'Discover';
    case 'mastercard':
      return 'Mastercard';
    default:
      return 'Other';
  }
}

export function getCardIcon(cardType) {
  switch (cardType) {
    case 'amex':
      return AmexIcon;
    case 'visa':
      return VisaIcon;
    case 'discover':
      return DiscoverIcon;
    case 'mastercard':
      return MasterCardIcon;
    default:
      return OtherPaymentIcon;
  }
}

export function getPaymentMethodIcon(paymentMethod) {
  switch (paymentMethod) {
    case ManualPaymentMethodValues.DIRECT_TRANSFER:
      return DirectTransferIcon;
    case ManualPaymentMethodValues.CASH:
      return CashIcon;
    case ManualPaymentMethodValues.CHECK:
      return CheckIcon;
    case ManualPaymentMethodValues.ZELLE:
      return ZelleIcon;
    case ManualPaymentMethodValues.OTHER:
      return OtherPaymentIcon;
    case PaymentMethods.MOBILE_CHECK_DEPOSIT:
      return CheckDepositIcon;
    default:
      return OtherPaymentIcon;
  }
}

export const getPaymentData = (receiptData: ReceiptByIdResponse) => {
  if (receiptData?.cardDetails?.cardLast4 && receiptData?.cardDetails?.network) {
    return (
      <>
        <div className="flex flex-wrap items-center justify-end">
          <img className="mr-1.5" src={getCardIcon(receiptData?.cardDetails?.network)} alt="" />
          <div className="ml-1">{getCardType(receiptData?.cardDetails?.network)}</div>
          <div className="ml-1">{receiptData?.cardDetails?.cardLast4}</div>
          {receiptData.isManualKeyed && <div className="ml-1">(Keyed-in)</div>}
        </div>
      </>
    );
  }
  return (
    <>
      {receiptData?.paymentMethod ? (
        <>
          <div className="flex flex-wrap items-center justify-end">
            <img className="mr-1.5" src={getPaymentMethodIcon(receiptData?.paymentMethod)} alt="" />
            <div className="ml-1">{receiptData?.paymentMethod}</div>
          </div>
          <If condition={Boolean(receiptData?.referenceNote)}>
            <div className="ml-2 mt-2 whitespace-normal text-end text-[13px] font-medium text-accentText">
              {receiptData?.referenceNote}
            </div>
          </If>
        </>
      ) : (
        <div>-</div>
      )}
    </>
  );
};

export const getRelatedItemsStatus = (status, type: string) => {
  switch (type) {
    case 'DISPUTE':
      return <div style={{ color: getDisputeStatusColor(status) }}>{getReceiptStatus(status)}</div>;
    case 'PAYOUT':
      return <div style={{ color: getPayoutStatusColor(status) }}>{getPayoutStatus(status)}</div>;
    case 'INVOICE':
      return <div style={{ color: getInvoiceStatusColor(status) }}>{getInvoiceStatus(status)}</div>;
    case 'REFUND':
      if (status === 'REFUND_RETURNED') {
        return <div style={{ color: '#3E556D' }}>Refund returned</div>;
      }
      return <div style={{ color: '#3E556D' }}>{getReceiptStatus(status)}</div>;
    case 'RECEIPT':
      return <div style={{ color: '#3E556D' }}>{getReceiptStatus(status)}</div>;
    default:
      return <div style={{ color: '#3E556D' }}>{status?.toLowerCase()}</div>;
  }
};

export const getPaymentMethod = ({ cardLast4, network, paymentMethod, isManualKeyed }) => {
  if (cardLast4 && network) {
    return (
      <>
        <div className="flex flex-wrap items-center gap-1">
          <div>{getCardType(network)}</div>
          <div>{cardLast4}</div>
          {isManualKeyed && <div>(Keyed-in)</div>}
        </div>
      </>
    );
  }
  let paymentMethodText = '';
  paymentMethodText = paymentMethod ? ManualPaymentMethods.find(item => item.key === paymentMethod)?.value : '';
  if (!paymentMethodText) {
    paymentMethodText = paymentMethod
      ? PaymentMethodsForInvoiceFilter.find(item => item.key === paymentMethod)?.value
      : '';
  }
  return <div>{paymentMethodText || '-'}</div>;
};
